<i18n src="@/locales/modules/CustomerTranslate.json"></i18n>
<template>
	<div class="data-list-container">
		<vs-table ref="table" class="stack-table" :sst="true" :data="products" :max-items="limit" :noDataText="$t('Notify.NoDataAvailable')" @sort="mixinHandleSort">
			<div slot="header" class="flex flex-grow justify-end">
				<vs-input @input="mixinHandleSearch" size="large" class="input-search mr-3 md:block lg:block xl:block hidden" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />
				<div class="md:flex lg:flex xl:flex hidden">
					<vs-button v-if="mixinIsCanCreateStockCard" class="w-30 font-bold mr-3" type="border" @click="addStockCard">{{ $t("StockCard") }}</vs-button>
					<vs-button v-if="mixinIsCanCreateProductStock" class="w-30 font-bold mr-3" type="border" @click="addProductStock">KCS</vs-button>
					<vs-button v-if="mixinIsCanCreateProduct" class="w-30 font-bold" type="filled" @click="addNewData">{{ $t("CreateProduct") }}</vs-button>
				</div>
			</div>

			<template slot="thead">
				<vs-th class="no-sorter"></vs-th>
				<vs-th sort-key="code">{{ $t("ProductCode") }}</vs-th>
				<vs-th sort-key="name" class="custom-sort-filter">{{ $t("ProductName") }}</vs-th>
				<vs-th sort-key="limit">{{ $t("Price") }}</vs-th>
				<vs-th sort-key="expired_days">{{ $t("ExpiredDays") }}</vs-th>
				<vs-th sort-key="quantity">{{ $t("Quantity") }}</vs-th>
				<vs-th sort-key="qty_limit">{{ $t("QtyLimit") }}</vs-th>
				<vs-th class="no-sorter"></vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody>
					<vs-tr class="cursor-pointer" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('GroupCustomer')" class="md:text-center">
							<img v-if="tr && tr.front_image && tr.front_image.path" :src="tr.front_image.path" alt="" class="w-16" />
							<img v-else src="@/assets/images/pages/no-product.png" alt="no-product" class="w-16" />
						</vs-td>
						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('Code')">
							<p class="text-base">{{ tr.code }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('FullName')">
							<p class="text-base">{{ tr.name }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('Limit')">
							<p class="text-base">{{ $helper.numFormat(tr.price) }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('ExpiredDays')">
							<p class="text-base">{{ $helper.numFormat(tr.expired_days) }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('Quantity')">
							<p class="text-base">{{ $helper.numFormat(tr.quantity) }}</p>
						</vs-td>

						<vs-td @click.native="handleClickItemRow($event, tr)" :data-header="$t('QtyLimit')">
							<p class="text-base">{{ $helper.numFormat(tr.qty_limit) }}</p>
						</vs-td>

						<vs-td class="whitespace-no-wrap text-right">
							<ProductContextMenu type="vertical" :productItem="tr" @onClickAddQuote="handleAddQuote" @onClickEdit="handleEdit" @onClickDelete="showDeleteConfirm" />
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<CbsPagination class="mt-3" :total="totalPages" v-model="page" />
		<ProductDetailDialog
			v-if="isDetailProductDialogActive"
			:product="detailProductDialogData"
			:isSidebarActive="isDetailProductDialogActive"
			@closeSidebar="toggleProductDetailSidebar"
			@onClickAddQuote="handleAddQuote"
			@onClickEdit="handleEdit"
			@onClickDelete="showDeleteConfirm"
		/>
		<ProductFormSideBar :data="productDialogData" :isSidebarActive="isProductFormDialogActive" @closeSidebar="toggleProductFormSidebar" />
		<StockCardForm :isSidebarActive="isShowStockCardForm" @closeSidebar="toggleStockCardForm" @importDataSuccess="refreshProductList" />
	</div>
</template>

<script>
import moduleCustomer from "@/store/customer/moduleCustomer";
import { withBasicQueries, productPermissions, stockCardPermissions, getUserPermissions, productStockPermissions } from "@/mixins/mixins.js";
import ProductDetailDialog from "./ProductDetailDialog.vue";
import ProductContextMenu from "./ProductContextMenu.vue";
import ProductFormSideBar from "./ProductFormSideBar.vue";
import StockCardForm from "./StockCardForm.vue";

export default {
	components: {
		ProductDetailDialog,
		ProductContextMenu,
		ProductFormSideBar,
		StockCardForm
	},
	mixins: [
		withBasicQueries,
		getUserPermissions({
			...productPermissions,
			...stockCardPermissions,
			...productStockPermissions
		})
	],
	computed: {
		products() {
			return this.$store.state.customerManagement.showProducts;
		},
		totalPages() {
			return Math.ceil(this.$store.state.customerManagement.totalShowProducts / this.limit);
		}
	},
	data() {
		return {
			page: 1,
			limit: 10,
			searchText: "",
			detailProductDialogData: {},
			isDetailProductDialogActive: false,
			productDialogData: {},
			isProductFormDialogActive: false,
			isShowStockCardForm: false
		};
	},
	watch: {
		page() {
			this.getProducts();
		},
		"$route.query"() {
			this.getProducts();
		},
		"$route.query.id"(newVal, oldVal) {
			console.log("newVal, oldVal", newVal, oldVal);
			if (Number(newVal) !== Number(oldVal) && this.$route.query.id) {
				this.viewDetail({ id: this.$route.query.id });
			}
		}
	},
	methods: {
		async getProducts() {
			this.$vs.loading();
			await this.$store.dispatch("customerManagement/fetchCustomerShowProducts", {
				page: this.page,
				search: this.searchText,
				limit: this.limit
			});
			this.$vs.loading.close();
		},
		addNewData() {
			this.productDialogData = {};
			this.toggleProductFormSidebar(true);
		},
		handleClickItemRow(event, product) {
			this.detailProductDialogData = product;
			this.toggleProductDetailSidebar(true);
		},
		toggleProductDetailSidebar(val) {
			this.isDetailProductDialogActive = val ? val : false;
		},
		toggleProductFormSidebar(val) {
			this.isProductFormDialogActive = val ? val : false;
		},
		handleAddQuote() {},
		handleEdit(product) {
			this.productDialogData = product;
			this.toggleProductFormSidebar(true);
		},
		async handleDelete(prod) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("customerManagement/deleteProduct", {
					id: prod.id
				});
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteProductSuccessful")
					}
				});
				if (this.isDetailProductDialogActive) {
					this.toggleProductDetailSidebar(false);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		showDeleteConfirm(prod) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.handleDelete(prod),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		addStockCard() {
			this.toggleStockCardForm(true);
		},
		toggleStockCardForm(val = false) {
			this.isShowStockCardForm = val;
		},
		addProductStock() {
			this.$router.push({
				name: this.$constant.PAGES_NAME.PAGE_CBS_KCS_NAME
			});
		},

		refreshProductList() {
			this.page = 1;
			this.getProducts();
		},
		async viewDetail(id) {
			try {
				this.$vs.loading();
				const product = await this.$store.dispatch("customerManagement/getProductItem", id);
				this.handleClickItemRow(null, product);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		}
	},
	created() {
		this.$store.registerModule("customerManagement", moduleCustomer);
		this.getProducts();
		if (this.$route.query.id) {
			this.viewDetail(this.$route.query.id);
		}
	},
	beforeDestroy() {
		this.$store.unregisterModule("customerManagement");
	}
};
</script>

<style></style>
